/* eslint-disable */
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);


const smoothScrollScripts = {
  init: function (smoothScroll) {
    this.scrollTriggerPlusLocomotiveScrollSettings(smoothScroll);
    this.back2TopBtn(smoothScroll)
    this.scrollToAnchor(smoothScroll)
    this.customImgParallax()
  },

  scrollToAnchor: function (smoothScroll) {
    const hash = window.location.hash;
    if (hash) {
      const target = document.querySelector(`[data-id='${hash.substring(1)}']`);
      if (target) {
        smoothScroll.scrollTo(target);
      }
    }

    window.addEventListener('click', (e) => {
      const anchorLink = e.target.closest('a[href*="#"]');
      if (anchorLink) {
        e.preventDefault();
        const anchorHref = anchorLink.getAttribute('href');
        const anchorHash = anchorLink.hash.substring(1);

        if (anchorHref.startsWith('#')) {
          const targetSection = document.querySelector(`[data-id=${anchorHash}]`);
          if (targetSection) {
            smoothScroll.scrollTo(targetSection);
          }
          return;
        }

        const anchorUrl = new URL(anchorLink.href);
        const currentUrl = new URL(window.location.href);

        if (anchorUrl.origin !== currentUrl.origin) {
          window.location = anchorLink.href;
          return;
        }

        if (anchorUrl.pathname === currentUrl.pathname) {
          const targetSection = document.querySelector(`[data-id=${anchorHash}]`);
          if (targetSection) {
            smoothScroll.scrollTo(targetSection);
          }
        } else {
          window.location = anchorLink.href;
        }
      }
    });
  },

  back2TopBtn: function (smoothScroll) {
    const btn = document.querySelector('#footer-btn-to-top');
    if (!btn) return;

    btn.addEventListener('click', () => {
      smoothScroll.scrollTo('top')
    })
  },

  scrollTriggerPlusLocomotiveScrollSettings: function (smoothScroll) {
    // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
    smoothScroll.on("scroll", ScrollTrigger.update);

    // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
    ScrollTrigger.scrollerProxy("[data-scroll-container]", {
      scrollTop(value) {
        return arguments.length ? smoothScroll.scrollTo(value, 0, 0) : smoothScroll.scroll.instance.scroll.y;
      },
      getBoundingClientRect() {
        return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
      },
      pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed",
    });

    // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
    ScrollTrigger.addEventListener("refresh", () => smoothScroll.update());

    // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
    ScrollTrigger.refresh();
  },

  customImgParallax: function () {
    const parallaxEls = document.querySelectorAll('[data-img-parallax]');
    if (!parallaxEls || parallaxEls.length === 0) return;

    parallaxEls.forEach((el) => {
      const img = el.querySelector('img');
      const section = el.closest('section');
      const direction = el.getAttribute('data-parallax-direction');
      const yFrom = direction === 'reverse' ? -60 : 60;
      const yTo = direction === 'reverse' ? 60 : -60;

      if (!img || !section) return;

      gsap.fromTo(img, {
        y: yFrom,
      }, {
        y: yTo,
        scrollTrigger: {
          trigger: section,
          scroller: '[data-scroll-container]',
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          // markers: true,
        },
        ease: "none",
      });
    })
  },
};

export default smoothScrollScripts;

